<script setup>
// assets/project/src/components/ExportCompetition.vue

import {ref, onMounted, watch, toRefs, onUnmounted} from 'vue'
import axios from 'axios'
import {Button} from 'ant-design-vue'
import {defineProps} from "vue"

const props = defineProps({
	competition: {
		type: Object,
		required: true
	},
	applyCategories: {
		type: Array,
		default: () => []
	}
})
const {competition, applyCategories} = toRefs(props)

const loading = ref(false)
const countExportRecords = ref(0)
const reportReady = ref(false)
const isOwnReport = ref(false)
const excelName = ref('')
const isLoading = ref(true)

const interval = ref(null)

const currentTaskId = ref(null)
const taskProgress = ref(null)
const reportExists = ref(false)

async function getExportStatus() {
	try {
		const {data} = await axios.get(`/competition/get_report_status/${competition.value.id}`)
		reportReady.value = data.reportReady
		excelName.value = data.exel_name
		reportExists.value = data.reportExists
		isLoading.value = false
		
		// Запускаем проверку статуса отчета только если отчет существует и не готов
		if (reportExists.value && !reportReady.value) {
			startCheckingReportStatus()
		}
	} catch (error) {
		console.error('Error getting export status:', error)
		isLoading.value = false
	}
}

function hideProgressBlock() {
	const modal = document.getElementById('modal')
	modal.classList.remove('is-active')
}

async function runEqueue(e, categoryName, competitionId, categoryId) {
	e.preventDefault()
	if (loading.value) return
	
	loading.value = true
	document.querySelector('.close_modal').style.display = 'none'
	document.getElementById('modal').classList.add('is-active')
	
	const res = await axios.post('/competition/runImportToYandex', null, {
		params: {
			competitionId,
			categoryId
		}
	})
	
	document.getElementById('category_copy_name').innerHTML = categoryName
	const total = res.data.total
	
	if (total == 0) {
		document.getElementById('category_copy_name').innerHTML += " (в этой категории нет заявок. Экспорт выполняться не будет.)"
		document.querySelector('.close_modal').style.display = 'block'
		loading.value = false
	} else {
		currentTaskId.value = `competition_${competitionId}`
		checkTaskProgress(total)
	}
}


function delay(ms) {
	return new Promise(resolve => setTimeout(resolve, ms))
}

function renderProgress(completed, failed, total, progress) {
	document.getElementById('completed_tasks').innerText = completed
	document.getElementById('total_tasks').innerText = total
	document.getElementById('progress_tasks').style.width = `${progress}%`
}

async function exportToYandex(competitionId, categoryId) {
	try {
		await axios.post('/competition/runScenarioToYandexCategory', {
			competitionId,
			categoryId
		})
		window.location.reload()
	} catch (error) {
		window.location.reload()
	}
}

async function checkTaskProgress(total) {
	if (interval.value) {
		clearInterval(interval.value)
		interval.value = null
	}
	
	interval.value = setInterval(async () => {
		try {
			// Запрашиваем прогресс через Redis вместо QueueService
			const {data} = await axios.post("/competition/getQueueResults", null, {
				params: {
					queue_name: currentTaskId.value,
					total: total
				}
			})
			
			renderProgress(data.completed, data.failed, total, data.progress)
			
			if (data.progress === 100) {
				await delay(1000)
				loading.value = false
				document.querySelector('.close_modal').style.display = 'block'
				clearInterval(interval.value)
				interval.value = null
				
				// Закрываем модальное окно
				hideProgressBlock()
				
				// Вместо перезагрузки страницы, получаем обновленный статус отчета
				await getExportStatus()
			}
		} catch (error) {
			console.error('Error checking task progress:', error)
			clearInterval(interval.value)
			interval.value = null
		}
	}, 2000)
}



async function exportXlsx(competitionId, categoryId) {
	try {
		loading.value = true
		document.querySelector('.close_modal').style.display = 'none'
		document.getElementById('modal').classList.add('is-active')
		document.getElementById('category_copy_name').innerHTML = "Экспорт в Excel"
		
		// Создаем FormData для отправки данных
		const formData = new FormData();
		formData.append('competitionId', competitionId);
		formData.append('categoryId', categoryId);
		
		// Получаем идентификатор задачи от сервера
		const response = await axios.post('/competition/runScenarioXlsCategory', formData);
		
		if (response.data && response.data.total) {
			currentTaskId.value = `competition_export_${competitionId}`
			const total = response.data.total
			
			if (total === 0) {
				document.getElementById('category_copy_name').innerHTML += " (в этой категории нет заявок. Экспорт выполняться не будет.)"
				document.querySelector('.close_modal').style.display = 'block'
				loading.value = false
			} else {
				// Запускаем проверку прогресса
				checkTaskProgress(total)
			}
		} else {
			throw new Error('Invalid server response')
		}
	} catch (error) {
		console.error('Export error:', error)
		loading.value = false
		document.querySelector('.close_modal').style.display = 'block'
	}
}

function startCheckingReportStatus() {
	if (interval.value) {
		clearInterval(interval.value);
		interval.value = null;
	}
	
	interval.value = setInterval(async () => {
		try {
			// Передаем ID конкурса в запрос
			const {data} = await axios.post('/competition/getReportState', null, {
				params: {
					competitionId: competition.value.id
				}
			});
			
			const countElement = document.getElementById('countRecords');
			
			if (countElement) {
				// Обрабатываем ответ в зависимости от типа данных
				if (typeof data === 'string' || typeof data === 'number') {
					countExportRecords.value = data;
					countElement.textContent = data;
					
					if (data === '-') {
						clearInterval(interval.value);
						interval.value = null;
						// Вместо перезагрузки страницы, обновляем статус отчета
						await getExportStatus();
					}
				} else {
					console.warn('Unexpected response format:', data);
				}
			} else {
				clearInterval(interval.value);
				interval.value = null;
			}
		} catch (error) {
			console.error('Ошибка обновления данных:', error);
			alert('Ошибка обновления данных. Обновите страницу.');
			clearInterval(interval.value);
			interval.value = null;
		}
	}, 3000);
}


onMounted(async () => {
	await getExportStatus()
	
	if (!reportReady.value) {
		startCheckingReportStatus()
	}
})
onUnmounted(() => {
	if (interval.value) {
		clearInterval(interval.value)
		interval.value = null
	}
})

</script>

<template>
	<div style="margin-top: 30px; margin-bottom: 30px;">
		<h2 id="exporth2" style="padding: 20px">Экспорт данных конкурса</h2>
		
		<template v-if="isLoading">
			<a-spin/>
		</template>
		<template v-else>
			<!-- Показываем блок только если отчет существует (был запрошен) -->
			<template v-if="reportExists">
				<!--		Если отчет готов и он для этого конкурса-->
				<div v-if="reportReady">
					<div v-if="excelName" style="margin-left: 20px; margin-bottom: 30px; border: 1px solid #ccc; padding: 20px">
						<p>
            <span style="color: green; margin-right: 20px;">
              <i class="fas fa-check-circle"></i>
            </span>
							<a target="_blank" :href="'/uploads/report.xlsx'">Ссылка для скачивания отчета Excel</a>
						</p>
						<p>Вы можете запросить подготовку следующего отчета ниже.</p>
					</div>
				</div>
				<!-- Отчет в процессе -->
				<div v-else>
					<div id="reportPrepare" style="margin-left: 20px; margin-bottom: 30px; border: 1px solid #ccc; padding: 20px">
						<p>Отчет готовится.</p>
						<p><a href="#exporth2" @click="() => window.location.reload()">Обновить страницу</a>.</p>
						<p>Количество добавленных записей: <strong><span id="countRecords">{{ countExportRecords }}</span></strong>
						</p>
						<p>Нажмите кнопку "Сброс", <strong>если количество добавленных записей долгое время не изменяется.</strong>
						</p>
						<p style="margin-top: 20px; margin-bottom: 20px;">
							<a :href="`/competition/${competition.id}/reset`" class="button2">Сброс</a>
						</p>
					</div>
				</div>
			</template>
			
			<p style="margin-left: 20px; margin-bottom: 50px;">
				Экспорт данных конкурса выполняется на аккаунт OOOMOVIESTART.
				<a href="https://disk.yandex.ru">https://disk.yandex.ru</a>.
				Создается папка с названием конкурса "{{ competition.name }}"
			</p>
			
			<template v-for="category in competition.categories" :key="category.id">
				<div>
					<a href=""
					   @click="(e) => runEqueue(e, category.name, competition.id, category.id)"
					   style="margin-left: 20px">
						Шаг 1. Экспорт на Яндекс.Диск из категории "{{ category.name }}"
						<i style="margin-left: 10px;" class="fas fa-file-export"></i>
					</a>
					
					
					<p>
						<a href=""
						   @click.prevent="() => exportXlsx(competition.id, category.id)"
						   style="margin-left: 20px">
							Шаг 2. Экспорт статистики категории "{{ category.name }}" (формат Excel)
						</a>
					</p>
					<hr>
				</div>
			</template>
			
			<p v-if="competition.id === '95'">
				<a href="/export_vector_yandex">Экспорт pdf</a>
			</p>
			<p>
				<a target="_blank"
				   style="margin-left: 20px"
				   :href="competition.id === '95' ? '/get_vector_xls/95' : `/competition/getScenarioXls/${competition.id}`">
					Экспорт общей информации по конкурсу (формат Excel)
				</a>
			</p>
			
			<template v-if="competition?.user?.username === 'fundregion2022@yandex.ru'">
				<div style="margin-left: 20px; margin-right: 20px; margin-top: 50px;">
					<p>Выгрузки отчетов конкурсов "Россия - взгляд в будущее!":</p>
					<p><a href="https://disk.yandex.kz/d/n9iPI2NXLaXu8Q" target="_blank">2025</a></p>
					<p><a href="https://disk.yandex.kz/d/NImmdhAtYipqkw" target="_blank">2024</a></p>
					<p><a href="https://disk.yandex.kz/d/uz2tD-Q5DYTQkQ" target="_blank">2023</a></p>
				</div>
				<div style="margin-left: 20px; margin-right: 20px; margin-top: 50px;">
					<p><a target="_blank" href="/competition/report_rvvb_excel">Выгрузка всех проектов конкурса</a></p>
					<p><a target="_blank" href="/rvvb/export_stat/137">Статистика по регионам</a></p>
				</div>
			
			</template>
		</template>
	</div>
</template>